import { ref, reactive } from '@nuxtjs/composition-api';

const categoriesFilters = ref([]);
const activeFilters = ref([]);
const pricesData = reactive({
  minPrice: 0,
  maxPrice: 0,
  priceRanges: [],
  selectedPrice: {
    min: 0,
    max: 0
  }
});

export default function useCommonFilters() {
  return {
    categoriesFilters,
    activeFilters,
    pricesData
  };
}
